var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgATriangle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 36,
    viewBox: "0 0 50 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "A triangle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 11",
    d: "M25.2053 0.295692L49.1275 34.7437C49.4959 35.2742 49.1163 36 48.4704 36L1.52952 36C0.883665 36 0.504031 35.2742 0.872424 34.7437L24.7946 0.295692C24.8941 0.152491 25.1059 0.152491 25.2053 0.295692Z",
    fill: "#00F6EF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 12",
    d: "M25.2063 11.3016L37.1435 28.7483C37.5068 29.2792 37.1266 30 36.4833 30L13.5167 30C12.8734 30 12.4932 29.2792 12.8564 28.7483L24.7937 11.3016C24.8929 11.1564 25.107 11.1564 25.2063 11.3016Z",
    fill: "#1E1E1E"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgATriangle);
export default __webpack_public_path__ + "static/media/A-Triangle.b54148db303a9b0ae55dc4c33b0ec838.svg";
export { ForwardRef as ReactComponent };